
export let sharedState = null

export function setSharedState(nextState = {}) {
  if (!nextState) {
    throw Error('invalid state')
  }
  sharedState = {...sharedState, ...nextState}

  localStorage.setItem('sharedState', JSON.stringify(sharedState))
}


export function resetSharedState() {
  const storedState = JSON.parse(localStorage.getItem('sharedState'))

  sharedState = storedState || {
    importedExcelRows: null,
    importedExcelMappings: null,
  }
}

resetSharedState()



// WEBPACK FOOTER //
// ./utilities/sharedState.js